import { HttpErrorResponse } from "@angular/common/http";
import {
  BILLING_SUBSCRIPTION_INACTIVE_ERROR_TYPE,
  WEBSOCKET_BILLING_SUBSCRIPTION_ENDED,
} from "./billing-lockout.constants";
import type { BillingSubscriptionEndedReason } from "./billing-lockout.constants";

export function isBillingApiRequest(url: string): boolean {
  return /\/billing(\/|$|\?)/.test(url);
}

export function isSubscriptionInactiveHttpError(
  error: HttpErrorResponse,
): boolean {
  return (
    error.status === 403 &&
    error.error?.errorType === BILLING_SUBSCRIPTION_INACTIVE_ERROR_TYPE
  );
}

/** User is already on reactivation or first-checkout billing — no modal / navigate. */
export function isBillingReactivationRoute(url: string): boolean {
  const path = url.split("?")[0].split("#")[0];
  return (
    path.startsWith("/activate-service") ||
    path.startsWith("/initial-setup/billing")
  );
}

export function isBillingSubscriptionEndedWebSocketMessage(
  message: Record<string, unknown>,
): message is {
  type: typeof WEBSOCKET_BILLING_SUBSCRIPTION_ENDED;
  reason?: BillingSubscriptionEndedReason;
  userId?: string;
  endedAt?: string;
} {
  return message["type"] === WEBSOCKET_BILLING_SUBSCRIPTION_ENDED;
}
